import { render, staticRenderFns } from "./SelectSocialType.vue?vue&type=template&id=f85cfb10&scoped=true"
import script from "./SelectSocialType.vue?vue&type=script&lang=js"
export * from "./SelectSocialType.vue?vue&type=script&lang=js"
import style0 from "./SelectSocialType.vue?vue&type=style&index=0&id=f85cfb10&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f85cfb10",
  null
  
)

export default component.exports